import CommonRowCard from "components/molecules/cards/CommonRowCard/CommonRowCard";
import { RowListContainer } from "./CommonRowList.style";

interface CommonRowListProps {
  data: string[];
  handleClick: (element: string) => void;
  handleDeleteClick: (element: string) => void;
}

const CommonRowList = ({ data, handleClick, handleDeleteClick }: CommonRowListProps) => {
  return (
    <RowListContainer>
      {data.map((element, _id) => (
        <CommonRowCard
          key={_id}
          title={element}
          handleClick={() => handleClick(element)}
          handleDeleteClick={() => handleDeleteClick(element)}
        />
      ))}
    </RowListContainer>
  );
};

export default CommonRowList;
